import { render } from "./HeroSection.vue?vue&type=template&id=e309e578"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=e309e578&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__